import {Checkbox, Select, Stack,} from '@mui/material';
import useStyles from './useStyles'
import MenuItem from "@mui/material/MenuItem";
import {SearchComponent} from "../Search/Search";
import {useContext, useState} from "react";
import {FilterContext} from "./Context";
import FilterSvg from "../../icons/Filter";
import ListItemText from "@mui/material/ListItemText";

const options2 = ['Модель', 'Choice B', 'Choice C'];

const Filter = () => {

    const classes = useStyles()
    const {selectGeoObjectValues, onSelectGeoObjectChange, onSelectTwoChange} = useContext(FilterContext);

    const [filterName, setFilterName] = useState([]);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;

        const calculatedValue = typeof value === 'string' ? value.split(',') : value

        setFilterName(calculatedValue)
        onSelectGeoObjectChange(calculatedValue)
    };

    const MenuProps = {
        MenuListProps: {
            style: {
                padding: 10,
            }
        },
    }

    return (
        <Stack direction="row" spacing={1} className={classes.menuHeadStack}>
            <div className={classes.filterIconWrapper}>
                <FilterSvg />
            </div>
            <Select
                labelId="select-label-geoObject"
                id="select-label-geoObject"
                multiple
                value={filterName}
                onChange={handleChange}
                variant="standard"
                className={classes.selectComponent}
                displayEmpty
                MenuProps={MenuProps}
                renderValue={(selected) => {
                    if (selected.length === 0) {
                        return <p>Все</p>;
                    }
                    return selected.join(', ');
                }}
            >

                {selectGeoObjectValues.map((value, index) => (
                    <MenuItem
                        key={index + value}
                        value={value}
                        className={classes.menuItem}
                    >
                        <Checkbox checked={filterName.indexOf(value) > -1} />
                        <ListItemText primary={value} />
                    </MenuItem>
                ))}
            </Select>
            <Select
                labelId="select-label-2"
                id="select-label-2"
                value={options2[0]}
                label="options2"
                onChange={onSelectTwoChange}
                variant="standard"
                className={classes.selectComponent}
            >
                {options2.map((value, index) => (
                    <MenuItem
                        key={index + value}
                        value={value}
                        className={classes.menuItem}
                    >{value}</MenuItem>
                ))}
            </Select>
            <SearchComponent />
        </Stack>
    );
}

export default Filter;
